import type { EditorSDK } from '@wix/platform-editor-sdk';

import { addFocusedPageChangedListener } from './focused-page-changed';
import { addUndoListener } from './undo';

export const addEventsListeners = async (editorSDK: EditorSDK) => {
  return Promise.all([addUndoListener(editorSDK), addFocusedPageChangedListener(editorSDK)]);
};
